import lodash from 'lodash';
import MapBoxGL from "mapbox-gl/dist/mapbox-gl.js";
import AppConfig from "../resources/AppConfig.js";
import { outageColorStops } from "../resources/outagePalette.js";

const constants = require(`../resources/constants.json`);
const severityLevelMedium = constants.SEVERITY_LEVEL_MEDIUM;
const severityLevelHigh = constants.SEVERITY_LEVEL_HIGH;
const darkModeVermontFillColor = "#586E72";
const vermontFillLayerId = "vermont-fill";

export default class Map {
	static isPageLoad = undefined;
	static MAPBOX_TOKEN = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN;
	static townOutages = undefined;
	static countyOutages = undefined;
	static utilityOutages = undefined;
	static mapPadding = undefined;
	static basePadding = undefined;
	static drawerPadding = undefined;
	static easeToPaddingDelay = undefined;

	constructor(townOutages, countyOutages, utilityOutages) {
		MapBoxGL.accessToken = Map.MAPBOX_TOKEN;
		this.isPageLoad = true;
		this.townOutages = townOutages;
		this.countyOutages = countyOutages;
		this.utilityOutages = utilityOutages;
		this.firstSymbolId = undefined;
	}

	async CreateOutageMap(isDarkMode, container, initialZoomPoint = undefined) {
		return new Promise((resolve, reject) => {
			this.isDarkMode = isDarkMode;
			this.configurePadding();
			let zoom = 7.5;
			const bounds = AppConfig.mapBounds;
			let center = AppConfig.mapCenter;
			if (initialZoomPoint) {
				zoom = 13;
				center = initialZoomPoint;
			}

			this.map = new MapBoxGL.Map({
				container: container,
				style: isDarkMode ? process.env.VUE_APP_MAPBOX_STYLE_DARK_MODE : process.env.VUE_APP_MAPBOX_STYLE,
				zoom: zoom,
				center: center,
				maxBounds: bounds
			});
			this.map.style.touchAction = 'false';
			this.map.dragRotate.disable();
			this.map.touchZoomRotate.disableRotation();

			this.map.on("load", async () => {
				this.setFirstSymbolId();
				this.updateVermontFillColor();

				try {
					this.addControls();
					this.FitVermont();
					this.loaded = true;
					this.setupEventHandlers();

					resolve();
				} catch (err) {
					reject(err);
				}
			});
		});
	}
	setDarkMode() {
		this.isDarkMode = true;
		this.map.once("style.load", () => this.updateVermontFillColor());
		this.map.setStyle(process.env.VUE_APP_MAPBOX_STYLE_DARK_MODE);
	}
	removeDarkMode() {
		this.isDarkMode = false;
		this.map.setStyle(process.env.VUE_APP_MAPBOX_STYLE);
	}
	updateVermontFillColor() {
		if (this.isDarkMode && this.map.getLayer(vermontFillLayerId)) {
			this.map.setPaintProperty(vermontFillLayerId, "fill-color", darkModeVermontFillColor);
		}
	}
	buildUtilitiesListItem(utility) {
		return `<li class="utility">
			<span class="key">${utility.name}:</span>${utility.customerCount} Customers
		</li>`;
	}
	buildUtilitiesList(utilities) {
		let html = '<ul class="utilities-list">';
		utilities.forEach(utility => html += this.buildUtilitiesListItem(utility));
		html += '</ul>';
		return html;
	}
	configurePadding() {
		this.easeToPaddingDelay = 800;
		this.basePadding = 80;
		this.drawerPadding = 425;
		this.mapPaddingMobile = {top: this.basePadding, bottom: (this.basePadding + 100)}
		this.mapPadding = {top: (this.basePadding + 40), bottom: this.basePadding, right: this.basePadding, left: this.basePadding}
	}
	setFirstSymbolId() {
		const layers = this.map.getStyle().layers;

		for (let i = 0; i < layers.length; i++) {
			if (layers[i].type === 'symbol') {
				this.firstSymbolId = layers[i].id;
				break;
			}
		}
	}
	updatePadding(delay) {
		this.map.easeTo({
			duration: delay || this.easeToPaddingDelay,
			padding:  this.mapPadding
		});
	}
	centerMapRelativetoDrawer(delay) {
		this.mapPadding.right = this.drawerPadding;
		this.updatePadding(delay);
	}
	centerMapRelativetoViewport(delay) {
		this.mapPadding.right = 0;
		this.updatePadding(delay);
	}
	setupEventHandlers() {
		// this.map.on(constants.EVENT_ZOOMEND, () => this.handleZoomEnd());
		this.map.on(constants.EVENT_MOUSEMOOVE, constants.LAYER_TOWN_BOUNDARY_FILL, (evt) => this.handleTownHover(evt));
		this.map.on(constants.EVENT_MOUSEOUT, constants.LAYER_TOWN_BOUNDARY_FILL, (evt) => this.handleMouseOut(evt));
		this.map.on(constants.EVENT_MOUSEMOOVE, constants.LAYER_COUNTY_BOUNDARY_FILL, (evt) => this.handleCountyHover(evt));
		this.map.on(constants.EVENT_MOUSEOUT, constants.LAYER_COUNTY_BOUNDARY_FILL, (evt) => this.handleMouseOut(evt));
		this.map.on(constants.EVENT_MOUSEMOOVE, constants.LAYER_UTILITY_BOUNDARY_FILL, (evt) => this.handleUtilityHover(evt));
		this.map.on(constants.EVENT_MOUSEOUT, constants.LAYER_UTILITY_BOUNDARY_FILL, (evt) => this.handleMouseOut(evt));
	}
    showTownsLayer() {
		this.mapView = 'town';
		if (this.uiUpdatecallback) {this.uiUpdatecallback(); }
		this.removeAllCustomLayers();
		this.ShowTownBordersLayer(this.townOutages);
		this.UpdateTownFillLayer(this.townOutages);
	}
	showCountiesLayer() {
		this.mapView = 'county';
		if (this.uiUpdatecallback) {this.uiUpdatecallback(); }
		this.removeAllCustomLayers();
		this.ShowCountyBordersLayer(this.countyOutages);
		this.UpdateCountyFillLayer(this.countyOutages)
	}
	showUtilitiesLayer() {
		this.mapView = 'utility';
		if (this.uiUpdatecallback) {this.uiUpdatecallback(); }
		this.removeAllCustomLayers();
		this.ShowUtilityBordersLayer();
		this.UpdateUtilityFillLayer(this.utilityOutages);
	}
	DisableAllInteraction() {
		this.map.boxZoom.disable();
		this.map.dragPan.disable();
		this.map.dragRotate.disable();
		this.map.keyboard.disable();
		this.map.doubleClickZoom.disable();
		this.map.scrollZoom.disable();
	}
	FitVermont() {
		const bounds = AppConfig.mapVermontBounds;
		const vermontBounds = new MapBoxGL.LngLatBounds(bounds.lng, bounds.lat);

		if (this.isDesktop) {
			this.map.fitBounds(vermontBounds, { padding: this.mapPadding });
			setTimeout(() => this.centerMapRelativetoDrawer(100), 100);
		} else {
			this.map.fitBounds(vermontBounds, { padding: this.mapPaddingMobile });
		}
	}
	ZoomToTown(townName) {
		const townBounds = this.getTownBounds(townName);
		if (townBounds) {
			this.map.setFilter("town-boundary-highlight", ["==", "TOWNNAMEMC", townName]);
			this.ZoomToShape(townBounds);
		}
	}
	ZoomToShape(boundary) {
		if (!boundary) return;
		if (Array.isArray(boundary[0]) && Array.isArray(boundary[0][0])) {
			boundary = [].concat(...boundary);
		}
		var bounds = boundary.reduce(function (bounds, coord) {
			return bounds.extend(coord);
		}, new MapBoxGL.LngLatBounds(boundary[0], boundary[0]));
		this.map.fitBounds(bounds, {
			padding: 80
		});
	}
	ZoomToPoint(point) {
		if (!point) return;
		this.map.flyTo({
			center: point,
			zoom: 13
		});
	}
	addControls() {
		this.map.addControl(new MapBoxGL.NavigationControl(), 'bottom-right');
		this.map.addControl(new MapBoxGL.AttributionControl({compact: true}));
	}
	addEmptyMapSource(sourceName) {
		this.map.addSource(sourceName, {
			type: "geojson",
			data: {
				"type": "FeatureCollection",
				"features": [],
			}
		});
	}
	getTownBounds(townName) {
		if (townName) {
			const town = this.masterTownList.find(item => item.properties.TOWNNAMEMC === townName);
			if (town) {
				return town.geometry.coordinates[0];
			}
		}
		return undefined;
	}
    removeAllCustomLayers() {
		const allLayers = this.map.getStyle().layers;
		const customLayers = [
			constants.LAYER_TOWN_BOUNDARY_FILL,
			constants.LAYER_TOWN_BOUNDARY_BORDER,
			constants.LAYER_TOWN_BOUNDARY_HOVER,
			constants.LAYER_COUNTY_BOUNDARY_FILL,
			constants.LAYER_COUNTY_BOUNDARY_BORDER,
			constants.LAYER_COUNTY_BOUNDARY_HOVER,
			constants.LAYER_UTILITY_BOUNDARY_FILL,
			constants.LAYER_UTILITY_BOUNDARY_BORDER,
			constants.LAYER_UTILITY_BOUNDARY_HOVER
		];

		allLayers.forEach(layer => {
			const matchingLayer = lodash.find(customLayers, customLayer => {
			return customLayer === layer.id;
			});

			if (matchingLayer) {
			this.map.removeLayer(layer.id);
			}
		});
	}
	layerExists(layerId) {
		const layers = this.map.getStyle().layers;
		return layers.some((layer) => layer.id === layerId);
	}
	setAllUtiltyMapLayersToTransparent() {
		const transparentColor = 'rgba(0, 0, 0, 0)';

		if (this.layerExists(constants.LAYER_UTILITY_BOUNDARY_FILL)) {
			this.map.setPaintProperty(constants.LAYER_UTILITY_BOUNDARY_FILL, 'fill-color', transparentColor);
		}

		if (this.layerExists(constants.LAYER_UTILITY_BOUNDARY_HOVER)) {
			this.map.setPaintProperty(constants.LAYER_UTILITY_BOUNDARY_HOVER, 'line-color', transparentColor);
		}
	}
	handleMouseOut() {
		this.setAllUtiltyMapLayersToTransparent();
		if (this.townHoverPopup) {this.townHoverPopup.remove(); }
		if (this.countyHoverPopup) {this.countyHoverPopup.remove(); }
		if (this.utilityHoverPopup) {this.utilityHoverPopup.remove(); }
	}
	handleZoomEnd() {
		// do not let the zoom level determine the
		// map view on page load
		if (this.isPageLoad) {
			this.isPageLoad = false;
			return;
		}

		const zoomLevel = Math.round(this.map.getZoom());

		if (zoomLevel <= 7) {
			this.showUtilitiesLayer();
		} else if (zoomLevel === 8) {
			this.showCountiesLayer();
		} else {
			this.showTownsLayer();
		}
	}
	getOffsetLatitude() {
		let offsetRatio = 1;
		const mapZoom = Math.round(this.map.getZoom())

		if (mapZoom > 8 && mapZoom < 12) {
			offsetRatio = mapZoom;
		} else if (mapZoom >= 12 && mapZoom < 14) {
			offsetRatio = mapZoom * 2;
		} else if (mapZoom >= 14 && mapZoom < 16) {
			offsetRatio = mapZoom * 8;
		} else if (mapZoom >= 16 && mapZoom < 17) {
			offsetRatio = mapZoom * 16;
		} else if (mapZoom >= 17 && mapZoom < 18) {
			offsetRatio = mapZoom * 32;
		} else if (mapZoom >= 18) {
			offsetRatio = mapZoom * 64;
		}

		return (constants.MAP_HOVER_LATITUDE_OFFSET / offsetRatio);
	}
    handleTownHover(evt) {
		const features = this.map.queryRenderedFeatures(evt.point);
		const feature = lodash.find(features, feature => feature.sourceLayer === 'town_boundaries');
		const matchingTownOutage = lodash.find(this.townOutages, to => to.code === feature.properties.TOWNNAMEMC);

		this.map.setFilter(constants.LAYER_TOWN_BOUNDARY_HOVER, ["==", "TOWNNAMEMC", feature.properties.TOWNNAMEMC]);

		if (this.townHoverPopup) {this.townHoverPopup.remove();}
		if (!matchingTownOutage) {return; }

		this.townHoverPopup = new MapBoxGL.Popup({
			closeButton: false,
			closeOnClick: false,
			anchor: "bottom"
		});
		this.townHoverPopup.setLngLat(calculateCenter(feature.geometry.coordinates[0]));

		const totalCustomers = parseInt(matchingTownOutage.totalCustomers);

		let body = "<div id='mapHoverPopup'>";
		if (totalCustomers) {
			body += "<div class='map-hover-utility-name'>"

			if (totalCustomers >= severityLevelMedium && totalCustomers < severityLevelHigh) {
				body += "<span class='severity-icon medium'></span>";
			} else if (totalCustomers >= severityLevelHigh) {
				body += "<span class='severity-icon high'></span>";
			}

			body += matchingTownOutage.name + ":</div>";
		} else {
			body += "<div class='map-hover-utility-name no-incidents'>" + matchingTownOutage.name + "</div>";
			body += "<div class='map-hover-text'>No Incidents</div>";
		}
		body += "<div class='map-hover-text'>" + this.buildUtilitiesList(matchingTownOutage.utilities) + "</div>";
		body += "</div>";

		// force the pop-up to appear slightly above the cursor
		evt.lngLat.lat += this.getOffsetLatitude();

		this.townHoverPopup.setHTML(body);
		this.townHoverPopup.setLngLat(Object.values(evt.lngLat)).addTo(this.map);
	}
    handleCountyHover(evt) {
		const features = this.map.queryRenderedFeatures(evt.point);
		const feature = lodash.find(features, feature => feature.sourceLayer === 'county_boundaries');
		const matchingCountyOutage = lodash.find(this.countyOutages, co => co.code === feature.properties.CNTYNAME);

		this.map.setFilter(constants.LAYER_COUNTY_BOUNDARY_HOVER, ["==", "CNTYNAME", feature.properties.CNTYNAME]);

		if (this.countyHoverPopup) {this.countyHoverPopup.remove();}
		if (!matchingCountyOutage) {return; }

		this.countyHoverPopup = new MapBoxGL.Popup({
			closeButton: false,
			closeOnClick: false,
			anchor: "bottom"
		});
		this.countyHoverPopup.setLngLat(calculateCenter(feature.geometry.coordinates[0]));

		const totalCustomers = parseInt(matchingCountyOutage.totalCustomers);

		let body = "<div id='mapHoverPopup'>";
		if (totalCustomers) {
			body += "<div class='map-hover-utility-name'>"

			if (totalCustomers >= severityLevelMedium && totalCustomers < severityLevelHigh) {
				body += "<span class='severity-icon medium'></span>";
			} else if (totalCustomers >= severityLevelHigh) {
				body += "<span class='severity-icon high'></span>";
			}

			body += matchingCountyOutage.name + ":</div>";
		} else {
			body += "<div class='map-hover-utility-name no-incidents'>" + matchingCountyOutage.name + " County:</div>";
			body += "<div class='map-hover-text'>No Incidents</div>";
		}
		body += "<div class='map-hover-text'>" + this.buildUtilitiesList(matchingCountyOutage.utilities) + "</div>";
		body += "</div>";

		// force the pop-up to appear slightly above the cursor
		evt.lngLat.lat += this.getOffsetLatitude();

		this.countyHoverPopup.setHTML(body);
		this.countyHoverPopup.setLngLat(Object.values(evt.lngLat)).addTo(this.map);
	}
    handleUtilityHover(evt) {
		const features = this.map.queryRenderedFeatures(evt.point);
		const feature = lodash.find(features, feature => feature.sourceLayer === 'utility_boundaries');
		const matchingUtilityOutage = lodash.find(this.utilityOutages, co => co.code === feature.properties.COMPANY);

		this.map.setFilter(constants.LAYER_UTILITY_BOUNDARY_HOVER, ["==", "COMPANY", feature.properties.COMPANY]);

		if (this.utilityHoverPopup) {this.utilityHoverPopup.remove();}
		if (!matchingUtilityOutage) {return; }

		const utilities = [];

		this.utilityOutages.forEach(utility => {
			if (matchingUtilityOutage.code === utility.code){
				utilities.push({
					name: utility.code,
					customers: parseInt(utility.totalCustomers)
				});
			}
		});

		const customerLookup = ["match", ["get", "COMPANY"]];

		for (const utility of utilities) {
			customerLookup.push(utility.name, utility.customers);
		}

		customerLookup.push(0);

		this.map.setPaintProperty(constants.LAYER_UTILITY_BOUNDARY_FILL, "fill-color", getTownColorExpression(customerLookup));
		this.map.setPaintProperty(constants.LAYER_UTILITY_BOUNDARY_HOVER, "line-color", "#333");

		this.utilityHoverPopup = new MapBoxGL.Popup({
			closeButton: false,
			closeOnClick: false,
			anchor: "bottom"
		});

		this.utilityHoverPopup.setLngLat(calculateCenter(feature.geometry.coordinates[0]));

		const totalCustomers = parseInt(matchingUtilityOutage.totalCustomers);
		const totalEvents = parseInt(matchingUtilityOutage.totalEvents);

		let body = "<div id='mapHoverPopup'>";
		if (totalCustomers) {
			body += "<div class='map-hover-utility-name'>"

			if (totalCustomers >= severityLevelMedium && totalCustomers < severityLevelHigh) {
				body += "<span class='severity-icon medium'></span>";
			} else if (totalCustomers >= severityLevelHigh) {
				body += "<span class='severity-icon high'></span>";
			}

			body += matchingUtilityOutage.name + ":</div>";
		} else {
			body += "<div class='map-hover-utility-name no-incidents'>" + matchingUtilityOutage.name + ":</div>";
		}
		body += "<div class='map-hover-text'>"
		body += `<span class='key'>${totalEvents}</span> Events / `
		body += `<span class='key'>${totalCustomers}</span> Customers`
		body += "</div>";
		body += "</div>";

		// force the pop-up to appear slightly above the cursor
		evt.lngLat.lat += this.getOffsetLatitude();

		this.utilityHoverPopup.setHTML(body);
		this.utilityHoverPopup.setLngLat(Object.values(evt.lngLat)).addTo(this.map);
	}
	ShowUtilityBordersLayer() {
		this.map.addLayer(require(`./maplayers/${constants.LAYER_UTILITY_BOUNDARY_BORDER}.json`), constants.TOWN_NAME_LAYER_NAME);
	}

	UpdateUtilityFillLayer(data) {
		this.map.addLayer(require(`./maplayers/${constants.LAYER_UTILITY_BOUNDARY_FILL}.json`), this.firstSymbolId);
		this.map.addLayer(require(`./maplayers/${constants.LAYER_UTILITY_BOUNDARY_HOVER}.json`), constants.TOWN_NAME_LAYER_NAME);
		const utilities = [];

		data.forEach(utility => {
			utilities.push({
				name: utility.code,
				customers: parseInt(utility.totalCustomers)
			});
		});

		const customerLookup = ["match", ["get", "COMPANY"]];

		for (const utility of utilities) {
			customerLookup.push(utility.name, utility.customers);
		}

		customerLookup.push(0);
		this.map.setPaintProperty(constants.LAYER_UTILITY_BOUNDARY_FILL, "fill-color", "transparent");
	}

	ShowTownBordersLayer() {
		this.map.addLayer(require(`./maplayers/${constants.LAYER_TOWN_BOUNDARY_BORDER}.json`), constants.TOWN_NAME_LAYER_NAME);
	}
	UpdateTownFillLayer(data) {
		this.map.addLayer(require(`./maplayers/${constants.LAYER_TOWN_BOUNDARY_FILL}.json`), this.firstSymbolId);
		this.map.addLayer(require(`./maplayers/${constants.LAYER_TOWN_BOUNDARY_HOVER}.json`), constants.TOWN_NAME_LAYER_NAME);
		const towns = [];

		data.forEach(town => {
			towns.push({
				name: town.code,
				customers: parseInt(town.totalCustomers)
			});
		});

		const customerLookup = ["match", ["get", "TOWNNAMEMC"]];

		for (const town of towns) {
			customerLookup.push(town.name, town.customers);
		}
		customerLookup.push(0);
		this.map.setPaintProperty("town-boundary-fill", "fill-color", getTownColorExpression(customerLookup));
	}
	ShowCountyBordersLayer() {
		this.map.addLayer(require(`./maplayers/${constants.LAYER_COUNTY_BOUNDARY_BORDER}.json`), constants.TOWN_NAME_LAYER_NAME);
	}
	UpdateCountyFillLayer(data) {
		this.map.addLayer(require(`./maplayers/${constants.LAYER_COUNTY_BOUNDARY_FILL}.json`), this.firstSymbolId);
		this.map.addLayer(require(`./maplayers/${constants.LAYER_COUNTY_BOUNDARY_HOVER}.json`), constants.TOWN_NAME_LAYER_NAME);

		const counties = [];

		data.forEach(town => {
			counties.push({
				name: town.code,
				customers: parseInt(town.totalCustomers)
			});
		});

		const customerLookup = ["match", ["get", "CNTYNAME"]];
		for (const town of counties) {
			customerLookup.push(town.name, town.customers);
		}
		customerLookup.push(0);
		this.map.setPaintProperty(constants.LAYER_COUNTY_BOUNDARY_FILL, "fill-color", getTownColorExpression(customerLookup));
	}
}

function getTownColorExpression(customerLookup) {
	return [
		"step",
		customerLookup,
		"hsla(0, 0%, 100%, 0)",
		1,
		outageColorStops[0],
		100,
		outageColorStops[1],
		250,
		outageColorStops[2],
		500,
		outageColorStops[3],
		1000,
		outageColorStops[4]
	]
}

function calculateCenter(boundary, bumpup = true) {
	if (!boundary) return;
	// Sometimes boundary comes in wrapped in an array...?
	if (Array.isArray(boundary[0]) && Array.isArray(boundary[0][0])) {
		boundary = [].concat(...boundary);
	}
	var bounds = boundary.reduce(function (bounds, coord) {
		return bounds.extend(coord);
	}, new MapBoxGL.LngLatBounds(boundary[0], boundary[0]));
	const center = bounds.getCenter();
	const top = bounds._ne.lat - (bounds._ne.lat - center.lat) / 4;
	if (bumpup) {
		return [center.lng, top];
	} else {
		return [center.lng, center.lat];
	}
}
